import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../service/theme.service';
import { IotDevicesViewService } from '../iot-devices-view.service';

@Component({
  selector: 'app-iot-devices-filters',
  templateUrl: './iot-devices-filters.component.html',
  styleUrls: ['./iot-devices-filters.component.css'],
  standalone: false
})
export class IotDevicesFiltersComponent {
  constructor(
    public theme: ThemeService,
    public view: IotDevicesViewService,
    private router: Router
  ) {}

  get thingGroupOptions() {
    return [
      { label: 'allGroups', value: '' },
      { label: 'DEV', value: 'dev' },
      { label: 'POC', value: 'poc' },
      { label: 'PRD', value: 'prd' },
    ];
  }

  reset() {
    this.view.clearFilters();
  }

  goToCreateDevice() {
    this.router.navigate(['device-create']);
  }
}
